<template>
  <iframe sandbox="allow-same-origin" :ref="'iframe' + threadMessage['@id']" width="100%" height="100%" frameborder="0" scrolling="no">
  </iframe>
</template>
<script>
export default {
  name: 'messageContent',
  props: {
    threadMessage: {}
  },
  mounted () {
    const iFrameEl = this.$refs['iframe' + this.threadMessage['@id']]
    const doc = iFrameEl.contentWindow.document
    doc.open()
    doc.write(this.threadMessage.message)
    doc.close()
    iFrameEl.onload = () => {
      iFrameEl.style.height = doc.body.scrollHeight + 'px'
    }
  }
}
</script>
